import api from "../../core/api";
import {
  ForgotPassword,
  Login,
  LoginResult,
  Register,
  ResetPasswordModel,
} from "../models/AccountModels";
import {
  ConfirmRegister,
  ConfirmRegisterResult,
  ConfirmInvite,
  ConfirmInviteResult
} from "../../customer/shared/models/customerModels";

export function login(model: Login): Promise<LoginResult> {
  return api.post<LoginResult>(`/v1/account/login`, model).then(x => x.data);
}

export function register(model: Register): Promise<void> {
  return api.post(`/v1/account/register`, model);
}

export function confirmRegister(model: ConfirmRegister): Promise<ConfirmRegisterResult> {
  return api.post<ConfirmRegisterResult>(`/v1/account/confirm-register`, model).then(x => x.data);
}

export function confirmInvite(model: ConfirmInvite): Promise<ConfirmInviteResult> {
  return api.post<ConfirmInviteResult>(`/v1/account/confirm-invite`, model).then(x => x.data);
}

export function forgotPassword(model: ForgotPassword): Promise<void> {
  return api.post('/v1/account/forgot-password', model);
}

export function resetPassword(model: ResetPasswordModel): Promise<void> {
  return api.post('/v1/account/reset-password', model);
}
